export interface ReportsAllFiltersAppyModels {
    applyMode: typeReportsAllFiltersApplyModes;
    dateFilter: {
        label: string;
        code: string;
        fromDate?: Date;
        toDate?: Date;
    };
    opportunityChannel?: any;
    accountChannel?: any;
    leadChannel?: any;
    channel?: any;
    warehouseLocation?: any;
    selectedTerritory?: any;
    selectedTerritoryIds?: number[];
    summaryWidgetCode?: string;
    summaryWidgetTheme?: string;
    summaryWidgetTitle?: string;
    filterRange?: string;
}

export const ReportsAllFiltersApplyModes = {
    applyOnly: 'applyOnly',
    applySave: 'applySave'
} as const;
export type typeReportsAllFiltersApplyModes = keyof typeof ReportsAllFiltersApplyModes;
